/* Iron+Steel v3 footer signup: subscribe in Klaviyo directly, then post to Shopify.

   The form posts to Shopify ({% form 'customer' %}) and Klaviyo's Shopify integration syncs
   the subscriber into the Newsletter list, which starts the Welcome Series. That covers a
   first-time signup, but not someone coming back: a profile Klaviyo suppressed earlier stays
   suppressed, because a Shopify-side opt-in does not lift a Klaviyo suppression, and a
   customer who is already subscribed in Shopify produces no consent change for the sync to
   carry. Either way the visitor signs up and hears nothing.

   Subscribing through Klaviyo's client endpoint records the signup as fresh consent, the way
   the old Klaviyo footer form did. The form then submits to Shopify as before, so the
   customer record and its footer-signup tag are still written.

   Klaviyo answers 202 even for a list id it does not know and drops the request silently,
   so the list id in the section settings must be right. Without JavaScript, or if Klaviyo
   is slow or unreachable, the form posts to Shopify exactly as it did before this script. */

(() => {
  const REVISION = '2026-10-15';
  const TIMEOUT = 3000;

  const subscribe = (form, email) => {
    const company = form.dataset.klaviyoCompany;
    const list = form.dataset.klaviyoList;
    if (!company || !list) return Promise.resolve(false);

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.klaviyoSource || 'Website footer',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), TIMEOUT);

    return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(company)}`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(body),
      signal: controller.signal,
      keepalive: true // survives the page navigation when the form then posts to Shopify
    })
      .then((res) => res.ok)
      .catch(() => false)
      .finally(() => clearTimeout(timer));
  };

  document.querySelectorAll('[data-footer-signup]').forEach((form) => {
    let handingOff = false;
    form.addEventListener('submit', async (e) => {
      if (handingOff) return;
      const field = form.querySelector('input[type="email"]');
      const email = field && field.value.trim();
      if (!email) return; // leave empty or invalid input to the browser's own validation

      e.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const label = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Signing up…';
      }

      await subscribe(form, email);

      // Hand back to Shopify so the customer record and its tags are still written.
      handingOff = true;
      if (button) {
        button.disabled = false;
        button.textContent = label;
      }
      form.submit();
    });
  });
})();
